/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useState } from 'react';
import { DataTable } from '@scuf/datatable';
import '../DetailBreakdownByMeter/CarbonDetailTabBreakdownByMeterTheme.scss';
import {
  getColumnDetails,
  IColumnConfig
} from './EnergyConsumptionByEquipmentTypeTableUtils';
import {
  EnergyDisaggregation,
  IAny,
  IRequestContext
} from '../../DashboardKPIWidgets/IEnergyManagementProps';
import './EnergyConsumptionByEquipmentTypeTableNILMTableTheme.scss';
import { useTranslation } from '@scuf/localization';

const EnergyConsumptionByEquipmentTypeTable = (props: {
  nilmTableData: any;
  energyDisaggregation: Array<EnergyDisaggregation>;
  interValType?: IAny;
  requestContext?: IRequestContext;
}) => {
  const [t, lng] = useTranslation();
  const {
    nilmTableData,
    energyDisaggregation,
    interValType,
    requestContext
  } = props;
  const [fieldSortOrder, setFieldSortOrder] = useState<number>(-1);
  const [sortFieldName, setSortFieldName] = useState<string>();
  const fuelTypeTableConfig = getColumnDetails(
    energyDisaggregation,
    interValType,
    requestContext,
    lng
  );

  return (
    <>
      <DataTable
        data={nilmTableData.value.disaggregationMap}
        className="emaas-NILM-energyConsumptionByEquipmentType"
        onSort={({ sortField, sortOrder }) => {
          setFieldSortOrder(sortOrder as number);
          setSortFieldName(sortField);
        }}
        sortField={sortFieldName}
        sortOrder={fieldSortOrder}
        scrollable={true}
        resizableColumns={true}
      >
        {fuelTypeTableConfig.map((column: IColumnConfig) => {
          return (
            <DataTable.Column
              field={column.field}
              header={column.header}
              sortable={column.sortable}
              initialWidth={column.width}
              align={column.align as IAny}
              renderer={(cellData) => {
                return column.renderer(cellData);
              }}
            />
          );
        })}
      </DataTable>
    </>
  );
};
export default EnergyConsumptionByEquipmentTypeTable;
